import { ReadMoreLink } from '@/components/common/ReadMoreLink'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboPreviewType } from '@/defs/combo'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'

import styles from './StatComboResults.module.scss'

type Props = {
  combo: ComboPreviewType
}

export const StatComboResults = ({ combo }: Props) => {
  const { buildRelative } = useLinkInternal()

  const route = buildRelative({
    colorId: combo.colorId,
    comboSlug: combo.id,
    section: 'combosFeatured',
  })
  const href = route ? `${route}#results` : undefined

  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='infinity'>Results</IconWithLabel>
      </h2>
      <ul>
        {combo.results.map((result, j) => (
          <li key={j}>{result}</li>
        ))}
      </ul>
      {href && (
        <p>
          <ReadMoreLink as='LinkRoute' href={href} />
        </p>
      )}
    </>
  )

  return (
    <StatCommonBox height='tall' label='Results' popover={popover}>
      <ul className={styles.container}>
        {combo.results.slice(0, 2).map((result, j) => (
          <li key={j}>
            <p className={styles.result}>{result}</p>
          </li>
        ))}
        {combo.results.length > 2 && (
          <li>
            <p className={styles.more}>
              +{combo.results.length - 2} more result<span>{combo.results.length - 2 > 1 ? 's' : ''}</span>
            </p>
          </li>
        )}
      </ul>
    </StatCommonBox>
  )
}
